import { Switch } from 'antd'
import styled from 'styled-components'

export const AntSwitch = styled(Switch)`
  &.ant-switch-checked {
    background-color: ${({ theme }) => theme.color.main};
  }
`
